import { Dialog, DialogContent, DialogTitle, IconButton, Popover } from '@mui/material';
import styled, { css }                                    from 'styled-components';
import { extraColor } from './muiTheme';

export const ModalFooter = styled.div<{ margin?: string }>`
  gap: 15px;
  display: flex;
  justify-content: flex-end;
  margin: ${({ margin }) => margin || '32px 0 0'};
`;

export const CloseModalIcon = styled(IconButton)`
  && {
    margin: ${({ theme: { spacing } }) => spacing(1)}px;
    padding: ${({ theme: { spacing } }) => spacing(1)}px;

    svg {
      width: 20px;
      height: 20px;
    }
  }
`;

interface IStyledDialogProps {
  width?: string;
  minwidth?: string;
  maxwidth?: string;
  height?: string;
  minheight?: string;
}

export const StyledDialog = styled(Dialog)<IStyledDialogProps>`
  && {
    margin: auto;
   
    .MuiPaper-root {
      max-width: 100%;
    }

    .MuiDialog-paper {
      margin: 0px;
      border-radius: 0; 
      
      ${({ width, minwidth, maxwidth }) =>
        css`
          width: ${width};
          min-width: ${minwidth};
          max-width: ${maxwidth};
        `};

      ${({ height }) =>
        height &&
        css`
          height: ${height};
          max-height: ${height};
        `};

      ${({ minheight }) => minheight && `min-height: ${minheight}`};
    }
  }
`;

export const StyledDialogTitle = styled(DialogTitle)<{ $isReduced?: boolean, $isDraggable?: boolean}>`
  justify-content: space-between;
  padding : 0px 8px;
  font-size: 18px;
  cursor: ${({ $isDraggable }) => $isDraggable ? 'move' : 'auto'};
  width: ${({ $isReduced }) => $isReduced && '100%'};
  position: ${({ $isReduced }) => $isReduced && 'absolute'};
  background-color: ${extraColor.palette.blue.light};
  border-top: 1px solid ${extraColor.palette.blue.main};
  border-bottom: 1px solid ${extraColor.palette.blue.main};
`;

export const StyledDialogContent = styled(DialogContent)`
  && {
    ${({ theme: { spacing } }) => css`
      padding: 0 ${spacing(3)} ${spacing(3)};
    `}
  }
`;

export const ModalFormFooter = styled.div`
  position: relative;
  display: flex;
  justify-content: flex-end;
  padding-right: 20px;
  padding-bottom: 20px;
`;

export const PopoverStyle = styled(Popover)`
  .MuiPaper-root.MuiPopover-paper {
    width: 595px;
    height: 835px;
    padding: 15px 24px 24px 24px;
    position: absolute;
  }
`;

export const PopOverHeaderWrapper = styled.div<{ isDraggable?: boolean }>`
  display: flex;
  justify-content: space-between;
  cursor: ${({ isDraggable }) => isDraggable ? 'move' : 'auto'}
`;